export default __webpack_public_path__ + "static/media/milho.cc9b0380.svg";